import { render, staticRenderFns } from "./summary-row.vue?vue&type=template&id=920af24a&scoped=true&"
import script from "./summary-row.vue?vue&type=script&lang=js&"
export * from "./summary-row.vue?vue&type=script&lang=js&"
import style0 from "./summary-row.vue?vue&type=style&index=0&id=920af24a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "920af24a",
  null
  
)

export default component.exports